const swipedata = [
  {
    name: "Project-1",
    source: require("../assets/projects/project1.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project_1",
    live: "https://live-class-assignment1.netlify.app/",
  },
  {
    name: "Project-2",
    source: require("../assets/projects/project2.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project2",
    live: "https://live-class-assignment2.netlify.app/",
  },
  {
    name: "Project-3",
    source: require("../assets/projects/project3.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project3",
    live: "https://live-class-assignment3.netlify.app/",
  },
  {
    name: "Project-4",
    source: require("../assets/projects/project4.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project4",
    live: "https://live-class-assignment4.netlify.app/",
  },
  {
    name: "Project-5",
    source: require("../assets/projects/project5.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project5",
    live: "https://live-class-assignment5.netlify.app/",
  },
  {
    name: "Project-6",
    source: require("../assets/projects/project6.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project6",
    live: "https://live-class-assignment6.netlify.app/",
  },
  {
    name: "Project-7",
    source: require("../assets/projects/project7.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project7",
    live: "https://live-class-assignment7.netlify.app/",
  },
  {
    name: "Project-8",
    source: require("../assets/projects/project8.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project8",
    live: "https://live-class-assignment8.netlify.app/",
  },
  {
    name: "Project-9",
    source: require("../assets/projects/project9.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project9",
    live: "https://live-class-assignment9.netlify.app/",
  },
  {
    name: "Project-10",
    source: require("../assets/projects/project10.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project10",
    live: "https://live-class-assignment10.netlify.app/",
  },
  {
    name: "Project-11",
    source: require("../assets/projects/project11.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project11",
    live: "https://live-class-assignment11.netlify.app/",
  },
  {
    name: "Project-12",
    source: require("../assets/projects/project12.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project12",
    live: "https://live-class-assignment12.netlify.app/",
  },
  {
    name: "Project-13",
    source: require("../assets/projects/project13.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project13",
    live: "https://live-class-assignment13.netlify.app/",
  },
  {
    name: "Project-14",
    source: require("../assets/projects/project14.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project14",
    live: "https://live-class-assignment14.netlify.app/",
  },
  {
    name: "Project-15",
    source: require("../assets/projects/project15.png"),
    github: "https://github.com/RishabhSingh12/Live_Class_Project15",
    live: "https://live-class-assignment15.netlify.app/",
  },
];

export default swipedata;
